import axios from 'axios';
import { SERVICE_URL } from '../../utils/api';

// ระบบคลังสินค้า (หน้าแม่บ้าน) -- เรียก /api/staff/v1/stock ชุดเดียวกับแอป iPad ในอนาคต (docs/inventory-system-plan.md ใน repo API)
// token แม่บ้านเดิม ส่งทาง header x-staff-token (แบบเดียวกับ MaintenanceWork)
export const stockRequest = (token) => (path, opts = {}) => axios({
  baseURL: SERVICE_URL,
  url: `staff/v1/stock/${path}`,
  headers: { 'x-staff-token': token || '' },
  ...opts,
});

// ทุก action ส่ง client_action_id (สร้างครั้งเดียวต่อการกดส่ง · ส่งซ้ำตอนเน็ตหลุดใช้ id เดิม) + occurred_at
export const newActionId = () => {
  try { if (window.crypto?.randomUUID) return window.crypto.randomUUID(); } catch (e) { /* ignore */ }
  // LINE เครื่องเก่าไม่มี randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    return (c === 'x' ? r : (r % 4) + 8).toString(16);
  });
};

export const INCIDENT_TYPES = [
  { v: 'lost', label: 'หาย' },
  { v: 'broken', label: 'แตก/พัง' },
  { v: 'stained', label: 'เปื้อนถาวร' },
  { v: 'worn', label: 'เสื่อมสภาพ' },
];

export const RESPONSIBLE = [
  { v: 'guest', label: 'ลูกค้าทำ' },
  { v: 'self', label: 'ฉันทำเอง' },
  { v: 'unknown', label: 'ไม่ทราบ' },
];

export const STATUS_COLOR = {
  reported: '#B26B0E', awaiting_ack: '#CD3E33', disputed: '#7A4FB0', pending_charge: '#2C6DAF',
  charged: '#0F8A56', absorbed: '#8A938B', waived: '#8A938B', recovered: '#0F8A56',
};

// ราคาลูกค้าตามประเภทความเสียหาย (หน้าตรวจห้องเงินประกัน) -- เปื้อน = ราคาเสียหายบางส่วน · หาย/แตก = ราคาหาย
export const guestPriceOf = (item, type) => {
  if (!item) return 0;
  const lost = Number(item.guest_lost_price) || 0;
  if (type === 'stained') return item.guest_damage_price !== null && item.guest_damage_price !== undefined ? Number(item.guest_damage_price) || 0 : lost;
  return lost;
};

export const money = (n) => Number(n || 0).toLocaleString('th-TH', { maximumFractionDigits: 2 });
export const errText = (e) => e?.response?.data?.message || 'ไม่สำเร็จ — สัญญาณเน็ตอาจไม่ดี ลองอีกครั้ง';

// localStorage อาจใช้ไม่ได้ (private mode / LINE บางเครื่อง) -> แค่ไม่เก็บร่าง
export const lsGet = (key) => {
  try { const v = window.localStorage.getItem(key); return v ? JSON.parse(v) : null; } catch (e) { return null; }
};
export const lsSet = (key, value) => {
  try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* ignore */ }
};
export const lsDel = (key) => {
  try { window.localStorage.removeItem(key); } catch (e) { /* ignore */ }
};
